export default "<p>skeleton-add works!</p>\n"